export const TRUE_MOBILE_MAX_WIDTH = 1024;

/**
 * Plain-function counterpart of the useTrueMobile hook, for non-React modules.
 * Returns true if the user agent is a mobile device OR the viewport is at most TRUE_MOBILE_MAX_WIDTH wide.
 * This is a non-reactive snapshot: call it at the moment you need the answer (e.g. inside a resize handler).
 * React components should use the useTrueMobile hook instead so they re-render on resize.
 */
export const isTrueMobile = (): boolean => {
  const mobileUserAgent =
    /iPhone|webOS|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
    (/Android/i.test(navigator.userAgent) && /Mobile/i.test(navigator.userAgent));
  const isPhoneWidth = window.innerWidth <= TRUE_MOBILE_MAX_WIDTH;
  return mobileUserAgent || isPhoneWidth;
};
